import React, { useMemo } from 'react';
import { Switch, Route } from 'react-router-dom';
import { SearchParamsProvider } from '../shared/packages/searchParamsManager';
import { ModalProvider } from '../shared/packages/modalManager';
import CreatePage from '../pages/create';
import DetailsPage from '../pages/details';
import CreateNewConfigPage from '../pages/createNewConfig';
import EditDesksPage from '../pages/editDesks';
import EditAddressesPage from '../pages/editAddresses';
import SetRoomsFromDatePage from '../pages/setRoomsFromDate';
import NotFoundPage from '../pages/notFound';
import { paths } from '../shared/configs/routing';
import { SetDeskNameModal } from '../controllers/SetDeskName';
import ChangeDesksSettingsPage from '../pages/changeDesksSettings';
import { useUserAcceptanceRole } from '../shared/hooks/userAcceptanceRole';
import styles from './index.module.scss';
import '../shared/styles/common.scss';

const routes = [
  {
    path: paths.main,
    exact: true,
    Component: DetailsPage,
  },
  {
    path: paths.create,
    Component: CreatePage,
  },
  {
    path: paths.createNewConfig,
    Component: CreateNewConfigPage,
  },
  {
    path: paths.editDesks,
    Component: EditDesksPage,
  },
  {
    path: paths.editAddresses,
    Component: EditAddressesPage,
  },
  {
    path: paths.setRoomsFromDate,
    Component: SetRoomsFromDatePage,
  },
  {
    path: paths.changeDesksSettings,
    Component: ChangeDesksSettingsPage,
  },
  {
    path: '*',
    Component: NotFoundPage,
  },
];

const directorAcceptancePaths = new Set([
  paths.create,
  paths.createNewConfig,
  paths.editDesks,
  paths.editAddresses,
  paths.setRoomsFromDate,
  paths.changeDesksSettings,
]);

const getRoutes = (role) => {
  if (role.isDirector) {
    return routes;
  }

  return routes.filter(({ path }) => !directorAcceptancePaths.has(path));
};

const RoomsAcceptance = () => {
  const role = useUserAcceptanceRole();

  const currentRoutes = useMemo(() => getRoutes(role), [role]);

  return (
    <SearchParamsProvider>
      <ModalProvider>
        <section className={styles.root}>
          <Switch>
            {currentRoutes.map(({ path, exact, Component }) => (
              <Route key={path} exact={exact} path={path}>
                <Component className={styles.content} />
              </Route>
            ))}
          </Switch>
        </section>
        {role.isDirector && <SetDeskNameModal />}
      </ModalProvider>
    </SearchParamsProvider>
  );
};

export default RoomsAcceptance;
